var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-start-1 col-end-13" }, [
    _vm.thread.type != "lineItem"
      ? _c(
          "div",
          {
            staticClass: " p-3 rounded-lg",
            class: [
              _vm.thread.type === "customer"
                ? "col-start-1 col-end-8"
                : "col-start-6 col-end-13"
            ]
          },
          [
            _c(
              "div",
              {
                staticClass: "flex flex-row items-center",
                class: [
                  _vm.thread.type === "message"
                    ? "justify-start flex-row-reverse"
                    : ""
                ]
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center h-8 w-8 rounded-full bg-indigo-500 flex-shrink-0 text-white"
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.getFirstCharacter(_vm.thread)) + " "
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "relative text-xs bg-white py-2 px-4 shadow rounded-md text-gray-800",
                    class: [_vm.thread.type === "message" ? "mr-3" : "ml-3"]
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-right text-gray-400 text-xs" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("messageTime")(_vm.thread.createdAt)
                            ) +
                            " "
                        )
                      ]
                    ),
                    _c("p", {
                      directives: [
                        { name: "linkified", rawName: "v-linkified" }
                      ],
                      domProps: { innerHTML: _vm._s(_vm.thread.body) }
                    }),
                    _vm.thread.attachments
                      ? _c(
                          "div",
                          _vm._l(_vm.thread.attachments, function(
                            attachment,
                            index
                          ) {
                            return _c("AttachmentItem", {
                              key: index,
                              attrs: { attachment: attachment }
                            })
                          }),
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ]
        )
      : _c("div", { staticClass: "text-center" }, [
          _c("span", {
            staticClass: "text-xs text-cool-gray-700 pb-4",
            domProps: { innerHTML: _vm._s(_vm.getLineItemText(_vm.thread)) }
          })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }